<template>
  <aside class="relative overflow-hidden col-span-2 lg:col-span-1 lg:max-w-md" :aria-label="content.header">
    <img
      v-if="content.assetUrl"
      :src="$storyblok.formatSrc(`${content.assetUrl}/m/341x256`)"
      :alt="content.altText"
      width="341"
      height="256"
      class="w-full object-cover"
      style="max-width: initial"
    />
    <img
      v-else
      src="/images/coming-soon.jpg"
      class="w-full"
      style="max-width: initial"
      :alt="`Placeholder image for ${content.header}`"
      width="341"
      height="256"
    />
    <div
      class="p-4 flex flex-col space-y-2 leading-none"
      :class="{
        'bg-gray-lighter text-gray-darkest': content.style === 'SPLIT_LIGHT',
        'bg-dark text-light': content.style === 'SPLIT_DARK',
      }"
    >
      <p class="font-bold text-2xl" :class="{ 'text-light': content.style === 'SPLIT_DARK' }">{{ content.header }}</p>
      <p class="text-sm leading-4">{{ content.body }}</p>
      <UniversalLink
        v-if="content.ctaLink && content.ctaText"
        :link="content.ctaLink"
        :open-new-window="content.ctaOpenNewWindow"
        class="flex items-center text-sm font-bold text-inherit cursor-pointer no-underline hover:no-underline after:absolute after:left-0 after:top-0 after:right-0 after:bottom-0"
        :aria-label="`${content.ctaText} - ${content.header}`"
      >
        <span>{{ content.ctaText || 'Shop Now' }}</span>
        <Arrow
          class="w-5 h-5 fill-current ml-2"
          :class="{ 'text-primary': content.style === 'SPLIT_DARK' }"
          aria-hidden="true"
        />
      </UniversalLink>
    </div>
  </aside>
</template>
<script setup lang="ts">
const { $storyblok } = useNuxtApp()
import Arrow from '@/assets/arrow-right.svg?component'

const { content } = defineProps<{
  content: RefinedContent['data']
}>()
</script>
